<organization-top-navbar></organization-top-navbar>
<div class="inline-block lg:px-28 py-4 padding-left-1-5rem">
  <button class="gap-2 flex items-center" (click)="(goBack())">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
      class="size-6 stroke-[#0D6EFD]">
      <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
    </svg>
    <p class=" font-medium text-sm text-[#0D6EFD]">{{'PARKIFLY.BACK_BUTTONS.BACK_TO_DETAILS' | transloco}}</p>
  </button>
</div>

<div class="Content lg:px-28 px-4 justify-end items-start gap-8 w-full flex lg:flex-row flex-col">
  <div class="UppgifterWrapper self-stretch flex-col justify-start items-start gap-4 inline-flex w-full">
    <div class="flex w-full justify-between">
      <div class="DinaUppgifter text-black text-lg font-bold  leading-loose">{{'PARKIFLY.PAYMENT.PAYMENT_METHOD' |
        transloco}}
      </div>

      <!-- Payment countdown -->
      @if (300 > countdown && countdown > 0) {
        <div
          class="w-2/4 flex items-center text-center px-4 py-2 rounded-md text-sm font-medium shimmer-text">
          <mat-icon class="mr-2">alarm</mat-icon>
          <span>{{ formatTime(countdown) }}</span>
        </div>
      }
    </div>

    <label
      class="PaymentInput self-stretch  p-8 bg-white rounded-xl shadow flex-col justify-start items-start gap-4 flex">
      <div class="PaymentInput self-stretch w-full block">
        <div class="mt-3 w-full" id="swedbank-pay-seamless-view-page"></div>
      </div>
    </label>
  </div>

  <div class="flex-col gap-8 inline-flex w-full basis-1/3 ">
    <app-summary [showBookingButton]="false"></app-summary>
  </div>

</div>